import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.updateClock()
    this.startClock()
  }

  disconnect() {
    this.stopClock()
  }

  startClock() {
    this.timer = setInterval(() => {
      this.updateClock()
    }, 30000)
  }

  stopClock() {
    clearInterval(this.timer)
  }

  updateClock() {
    let now = new Date();
    this.timeTarget.innerText = now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }
}